import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    IS_JAMPA,
    API_URL,
} from "shared/api/client";
import {installReloginFetch} from "shared/api/reloginFetch";
import {installDemoReadOnly} from "shared/api/demoReadOnly";

installReloginFetch(API_URL);
installDemoReadOnly(API_URL);

function setBranding(isJampa: boolean) {
    // סימון המותג על שורש המסמך — כך ערכי הטוקנים מגיעים גם לפופאפים שנפתחים מחוץ למרחב
    document.documentElement.classList.toggle('is-jampa', isJampa);
    document.title = isJampa ? 'Jampa' : 'HK';
    /* נתיב מוחלט בכוונה: נתיב יחסי נפתר מול המסך הנוכחי, ובמסך פנימי כמו
       /workspace/companies/216/reports השרת מחזיר את index.html במקום האייקון
       והדפדפן נופל לגלובוס הגנרי (אייל 27.09). */
    const href = isJampa ? '/favicon-jampa.ico' : '/favicon.ico';
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.type = 'image/x-icon';
    link.href = href;
}

setBranding(IS_JAMPA);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

